import { useApiContext, useGetUserCountry } from 'react-easyrocket';
import { getAffiliateData } from '../useGetCountryConfig/utils/getAffiliateData';

export function useIsUkGuest() {
  const { isGBR } = useGetUserCountry();
  const { isAuthenticated } = useApiContext();
  const hasAffiliateLink = getAffiliateData();

  /** Пользователь из UK, не авторизован и без реферальной ссылки */
  return isGBR && !isAuthenticated && !hasAffiliateLink;
}
